module.exports = __webpack_public_path__ + "static/img/bottom-button-2-down.3b7aab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/bottom-button-2-down.png
// module id = KWsS
// module chunks = 1